import React, { useEffect, useState } from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import "./GalleryDataRepurchase.css";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const GalleryDataRepurchase = () => {
  const { access } = JSON.parse(localStorage.getItem("authTokens"));
  const [loading, setLoading] = useState(false);
  const [purchasedItems, setPurchasedItems] = useState([]);
  const [itemSelectedArray, setItemSelectedArray] = useState([]);
  const [itemIds, setItemIds] = useState({});
  console.log(itemIds, "itemIds");

  const handleSelection = (index, id) => {
    console.log(index, id);
    const updatedArray = [...itemSelectedArray];
    updatedArray[index] = !updatedArray[index];
    if (updatedArray[index] === true) {
      setItemIds({ ...itemIds, [index]: id });
    } else {
      const updatedItemIds = { ...itemIds };
      delete updatedItemIds[index];
      setItemIds(updatedItemIds);
    }

    setItemSelectedArray(updatedArray);
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/maintenance/annual-pass/expired`,
        {
          headers: { Authorization: "Bearer " + access },
        }
      )
      .then((response) => {
        setPurchasedItems(response.data);
        setItemSelectedArray(Array(response.data.length).fill(false));
        setLoading(false);
      })
      .catch((e) => console.log(e.message));
  }, []);

  return (
    <div>
      <Header />
      {/* THe following div is added to avoid space of header. header's height is 93px */}
      <div style={{ height: "93px" }}></div>

      <div className="data-repurchase-main-div">
        <CardDiv />
        <TableDiv
          itemSelectedArray={itemSelectedArray}
          purchasedItems={purchasedItems}
          handleSelection={handleSelection}
          loading={loading}
          totalItemsSelected={
            itemSelectedArray.filter((item) => item === true).length
          }
          itemIds={itemIds}
        />
        <LastDiv />
      </div>
      <Footer />
    </div>
  );
};

const CardDiv = () => {
  return (
    <div className="data-repurchase-first-div">
      <span className="card">データ再購入</span>
      <p className="data-repurchase-first-div-text">
        保管期限が切れたデータは、購入後、再度アップロードいたします。
        <br />
        決済後、通常1日以内にデータは反映されます。（保管期限：3ヶ月）
        <br />
        ※年末年始休業・定休日の場合は、データの反映が遅れますのでご了承ください。
      </p>
    </div>
  );
};

const TableDiv = ({
  purchasedItems,
  itemSelectedArray,
  handleSelection,
  loading,
  totalItemsSelected,
  itemIds,
}) => {
  const navigate = useNavigate();
  const fixedPrice = 1650;
  return (
    <div className="table-div">
      <div className="table-div-top">
        <div className="table-div-top-first">保管期限切れデータ</div>
        <div className="table-div-top-second">
          再度購入するギャラリーを選択してください。（1プラン￥{fixedPrice}）
        </div>
      </div>
      <div class="table-div-table">
        <div style={{ backgroundColor: "#efeee5" }}>
          <div class="table-div-table-header">
            {[
              "アップロード日",
              "ギャラリー名",
              "保管期限",
              "データ容量",
              "希望のデータを選択\nしてください",
            ].map((item, i) => {
              return (
                <div class="table-div-header-cell" key={i}>
                  {item}
                </div>
              );
            })}
          </div>
        </div>
        <div class="table-div-body">
          {loading && (
            <div class="loading">
              <FaSpinner class="loadingIcon" />
              <span>読み込み中 ...</span>
            </div>
          )}
          {!loading &&
            itemSelectedArray &&
            itemSelectedArray.map((isSelected, index) => {
              return (
                <div class="table-div-row" key={index}>
                  <div class="table-div-cell">
                    {purchasedItems[index].buy_date}
                  </div>
                  <div class="table-div-cell">
                    七五三
                    <br />
                    {purchasedItems[index].expiry_date}撮影
                  </div>
                  <div class="table-div-cell">保管期限切れ</div>
                  <div class="table-div-cell">
                    {purchasedItems[index].storage}MB
                  </div>
                  <div class="table-div-cell">
                    <TableDivBtn
                      isSelected={isSelected}
                      handleSelection={handleSelection}
                      index={index}
                      itemId={purchasedItems[index].id}
                    />
                  </div>
                </div>
              );
            })}
          {!loading && purchasedItems?.length === 0 && (
            <p className="text-danger my-3 font-weight-bold">
              No previous purchase found!!!
            </p>
          )}
        </div>
      </div>

      <div className="table-div-bottom">
        <div>
          <div className="show-amount-div">
            <span>期限切れデータ購入</span>
            <span>
              {totalItemsSelected}件(¥{totalItemsSelected * fixedPrice})
            </span>
          </div>
        </div>
        <div className="pt-3 pb-5">
          <button
            disabled={!purchasedItems?.length > 0}
            className="table-div-bottom-btn"
            onClick={() => {
              if (
                itemSelectedArray?.filter((item) => item === true).length > 0
              ) {
                navigate("/cart-data-repurchase", {
                  state: {
                    numberOfItems: totalItemsSelected,
                    totalPrice: totalItemsSelected * fixedPrice,
                    itemIds: Object.values(itemIds),
                  },
                });
              } else {
                alert("Please Select an item.");
              }
            }}
          >
            ご注文手続きへ
          </button>
        </div>
      </div>
    </div>
  );
};

const TableDivBtn = ({ isSelected, handleSelection, index, itemId }) => {
  return (
    <button
      onClick={() => {
        console.log(isSelected);
        handleSelection(index, itemId);
      }}
      className={`btn ${isSelected ? "btn-selected" : "btn-not-selected"}`}
    >
      データを購入する
      {isSelected ? <span className="badge badge-selected">解除</span> : null}
    </button>
  );
};

const LastDiv = () => {
  return (
    <div className="last-div">
      <h5 className="last-div-header">過去のデータを購入希望の場合</h5>
      <p>
        過去にAcestudioで撮影したデータが、当ギャラリー上にない場合はLINEからお問い合わせください。
        <br />
        １年以内のデータは購入が可能です。
        <br />
        ※ご来店の年度が３年以上前の場合やイベントのお写真は保管期限外の場合がございます。ご了承くださいませ。
      </p>
    </div>
  );
};

export default GalleryDataRepurchase;
